import React from 'react';
import { ClipboardCheck, ArrowDown } from 'lucide-react';

// Replaces the empty SummaryStrip slot when the seller is fresh — no
// assessment scorecard yet AND zero advisory team members. Offers two
// complementary paths in: take the readiness assessment, or skip
// straight to the team block below.
export default function PreAssessmentHero() {
  const handleSkipToTeam = (e) => {
    e?.preventDefault?.();
    if (typeof window === 'undefined' || !document) return;
    const block = document.getElementById('succession-team-block');
    if (block) block.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.ahoy?.track) {
      try { window.ahoy.track('succeedo_dashboard_pre_assessment_skip_to_team_clicked'); } catch (_e) {}
    }
  };

  const handleStartAssessment = () => {
    if (typeof window !== 'undefined' && window.ahoy?.track) {
      try { window.ahoy.track('succeedo_dashboard_pre_assessment_start_clicked'); } catch (_e) {}
    }
  };

  return (
    <section className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-[16px] p-8 mb-8">
      <div className="font-mono text-[11px] uppercase tracking-wide text-[hsl(var(--succeedo-orange))] mb-3">
        WELCOME TO SUCCEEDO
      </div>
      <h2 className="font-serif text-[28px] font-light text-foreground tracking-[-0.01em] mb-3">
        Two ways to get started
      </h2>
      <p className="text-[14px] text-muted-foreground max-w-2xl mb-6">
        <strong className="text-foreground">Take the readiness assessment</strong> to see where you stand against benchmarks and get a personalised 90-day plan, or <strong className="text-foreground">skip straight to your team</strong> below — add the advisors you already work with and find anyone you're missing. Both paths converge.
      </p>
      <div className="flex items-center gap-3 flex-wrap">
        <a
          href="/succeedo/assessment"
          onClick={handleStartAssessment}
          className="inline-flex items-center gap-2 bg-[hsl(var(--succeedo-orange))] text-white rounded-full px-5 py-[10px] text-[14px] font-medium hover:opacity-90 transition-opacity"
        >
          <ClipboardCheck className="w-4 h-4" />
          Take the assessment
        </a>
        <button
          type="button"
          onClick={handleSkipToTeam}
          className="inline-flex items-center gap-2 border border-border text-foreground rounded-full px-5 py-[10px] text-[14px] hover:bg-accent transition-colors"
        >
          <ArrowDown className="w-4 h-4" />
          Skip — start with my team
        </button>
      </div>
    </section>
  );
}
